import styled from "styled-components"
import {Col} from "react-bootstrap"

import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import SvgCard from "@irati/ui/src/Layout/SvgCard"

export const StyledTemplate = styled.div`
  color: ${greys.dark};
  cursor: pointer;
  padding: ${padding.base} ${padding.tiny};
  position: relative;
  text-align: center;
`

interface StyledSvgCardProps {
  isSelected: boolean
}

export const StyledSvgCard = styled(SvgCard)<StyledSvgCardProps>`
  border-radius: 3px;
  box-shadow: ${(props) => (props.isSelected ? `0px 0px 8px ${greys.medium}` : "none")};
  border: ${(props) => (props.isSelected ? "none" : `5px solid ${greys.white}`)};
  margin-bottom: ${padding.tiny};
  overflow: hidden;
`

export const IconWrapper = styled.div`
  background: ${greys.white};
  border-radius: 50px;
  height: 50px;
  margin: 0 auto;
  padding-top: 12px;
  text-align: center;
  width: 50px;
`

export const StyledTemplatesCol = styled(Col)`
  height: 300px;
  overflow: scroll;
  padding-top: 6px;
`

export const StyledFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

export const StyledDiv = styled.div`
  color: ${greys.dark};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 50%;
  position: relative;
  text-align: center;
  width: 100%;
`

export const StyledWrapper = styled.div`
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(61, 61, 54, 0.25);
  height: calc(100% + 70px);
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
`
